export default __webpack_public_path__ + "static/media/nomap.2dfd512c.gltf";